<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <div>
          <!-- <v-btn
            class="ma-2"
            color="primary"
            outlined
            v-if=" selected.length == 1"
            @click="$router.push('/motor-perf-edit/'+selected[0].idmotor)"
          >Edit</v-btn>-->

          <v-btn v-if=" selected.length > 1" text @click="deleteMotorPerf" color="red">Delete Items</v-btn>

          <v-btn class="ma-2" color="primary" @click="$router.push('/motor-performance-add')">
            <v-icon left dark>mdi-chart-line-stacked</v-icon>
            {{$t('add_motor_performance_datas')}}
          </v-btn>
          
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-card>
        <v-card-title>
          {{$t('motor_performance_datas')}}
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('search')"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          item-key="idmotor_perf"
          :single-select="false"
          show-select
          v-model="selected"
          :headers="headers"
          :items="perfs"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <!-- <v-toolbar-title> -->

              <v-col cols="12" md="3" sm="3">
                <v-select
                  width="200"
                  v-model="selectedMotorTypeId"
                  :items="motorTypes"
                  :label="$t('motor.type')"
                ></v-select>
              </v-col>
              <v-col cols="12" md="3" sm="3">
                <v-select width="200" v-model="selectedMotorId"
                 :items="motors" :label="$t('motor.motor')"></v-select>
              </v-col>

              <!-- </v-toolbar-title> -->
              <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">{{$t('new_item')}}</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }} : {{ editedItem.model }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col v-if="editedIndex == -1" cols="12" md="4" sm="4">
                          <v-select
                            width="200"
                            v-model="selectedMotorTypeId"
                            :items="motorTypes"
                            :label="$t('motor.type')"
                          ></v-select>
                        </v-col>
                        <v-col v-if="editedIndex == -1" cols="12" md="4" sm="4">
                          <v-select
                            width="200"
                            v-model="editedItem.idmotor"
                            :items="motors"
                            :label="$t('motor.motor')"
                          ></v-select>
                          <!-- <v-text-field v-model="editedItem.stage" label="Stage"></v-text-field> -->
                        </v-col>

                        <v-col cols="12" md="4" sm="4">
                          <v-text-field v-model="editedItem.frequency" suffix="Hz" :label="$t('find.frequency')"></v-text-field>
                        </v-col>

                      </v-row>
                      <v-row>
                        <!-- <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.stage" label="Stage"></v-text-field>
                        </v-col>-->

                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.voltage" suffix="V" :label="$t('motor.voltage')"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.rpm" suffix="RPM" label="RPM"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.In" suffix="A" label="In"></v-text-field>
                        </v-col>
                       

                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.eff50" suffix="" label="Eff_50"></v-text-field>
                        </v-col>
  <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.eff75" suffix="" label="Eff_75"></v-text-field>
                        </v-col>
  <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.eff100" suffix="" label="Eff_100"></v-text-field>
                        </v-col>
                      </v-row>
                      
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.cosfi50" suffix="" label="Cosfi_50"></v-text-field>
                        </v-col>
  <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.cosfi75" suffix="" label="Cosfi_75"></v-text-field>
                        </v-col>
  <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.cosfi100" suffix="" label="Cosfi_100"></v-text-field>
                        </v-col>
                      </v-row>
                      
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">{{$t('cancel')}}</v-btn>
                    <v-btn color="blue darken-1" text @click="save">{{$t('save')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
            <v-icon small @click="deleteItem(item)">delete</v-icon>
          </template>
          <template v-slot:no-data>
            <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
          </template>
        </v-data-table>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "HelloWorld",
  data: () => ({
    token: "",
    dialog: false,
    motors: [],
    selectedMotorId: "",
    selectedMotorTypeId: "",
    selected: [],
    editMotorPerfId: 100,
    search: "",
    perfs: [],
    
    editedIndex: -1,
    editedItem: {
      idmotor_perf: -1,
      voltage: "",
      rpm: "",
      In: 0,
      eff50: 0,
      eff75: 0,
      eff100: 0,
      cosfi50: 0,
      cosfi75: 0,
      cosfi100: 0,
      frequency: 0,
    },
    defaultItem: {
      idmotor_perf: -1,
      voltage: "",
      rpm: "",
      In: 0,
      eff50: 0,
      eff75: 0,
      eff100: 0,
      cosfi50: 0,
      cosfi75: 0,
      cosfi100: 0,
      frequency: 0,
    },
    motorTypes: [],
    motor: {
      idmotor: -1,
      model: "XSP 20",
      material: "Stainless Steel",
      motorid: "10",
      nominal_diameter: "6",
      stage: 50,
      max_shaft_power: 100,
      p2: 70,
      diameter_outlet: 40,
      weight: 6,
      lp: 65
    }
  }),

  computed: {
    headers() { return [
      {
        text: this.$t('find.frequency'),
        align: "left",
        sortable: true,
        value: "frequency"
      },
      { text: this.$t('motor.voltage'), value: "voltage" },
      { text: "Rpm", value: "rpm" },
      { text: "In", value: "In" },
      // { text: "Eff25", value: "eff25" },
      { text: "Eff_50", value: "eff50" },
      { text: "Eff_75", value: "eff75" },
      { text: "Eff_100", value: "eff100" },
      // { text: "Cosfi25", value: "cosfi25" },
      { text: "Cosfi_50", value: "cosfi50" },
      { text: "Cosfi_75", value: "cosfi75" },
      { text: "Cosfi_100", value: "cosfi100" },
      { text: this.$t('actions'), value: "action", sortable: false }
    ]},
    formTitle() {
      return this.editedIndex === -1 ? this.$t('new_item_data') : this.$t('edit_item_data');
    },
    motorTypeChanged() {
      return this.editedItem.type
    }
  },

  watch: {
    // motorTypeChanged() {
    //   if (this.editedItem.type == null) return;
    //   if ( this.editedIndex == -1) return;
      
    //   this.selectedMotorId = "";
    //   this.selectedMotorTypeId = this.editedItem.type
    //   this.fetchMotors(this.editedItem.type);
    // },
    dialog(val) {
      val || this.close();
    },
    selectedMotorTypeId(val) {
      if (val == null) return;
      this.selectedMotorId = "";
      this.fetchMotors(val);
    },
    selectedMotorId(val) {
      this.fetchMotorPerformances(val);
    }
  },

  // created () {
  //     this.initialize()
  //   },

  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    this.fetchMotorTypes();
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.perfs.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.selected = [item];
      this.deleteMotorPerf();
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        // update
        // Object.assign(this.perfs[this.editedIndex], this.editedItem);
        this.saveMotorData(true, this.editedItem);
      } else {
        // save new
        // this.perfs.push(this.editedItem);
        this.saveMotorData(false, this.editedItem);
      }
    },

    deleteMotorPerf: function() {
      confirm(this.$t('confirm_delete')) &&
        this.selected.forEach(this.deleteDataRequest);
      this.selected = [];
      // console.log("selected bosaltildi.");
    },
    deleteDataRequest: function(perf) {
      this.$http
        .get(this.$API_URL + "motor-perf-delete?idmotor_perf=" + perf.idmotor_perf)
        .then(result => {
          console.log(result.data);
          if (this.selected.length == 0) this.fetchMotorPerformances(this.selectedMotorId);
        });
    },
    fetchMotorPerformances: function(motorId) {
      
      var query = "";
      if (motorId != "") 
        query = "?motorid=" + motorId;
      else
        return
      
      this.$http.get(this.$API_URL + "motor-perfs" + query).then(result => {
        this.perfs = result.data;
      });
    },

    fetchMotors: function(motorTypeId) {
      this.motors = [];
      console.log("fetchMotors for motortype id: " + motorTypeId);
      motorTypeId = this.selectedMotorTypeId;
      var query = "";
      if (motorTypeId != null) query = "?motortypeid=" + motorTypeId;

      this.$http.get(this.$API_URL + "motors" + query).then(result => {
        result.data.forEach(motor => {
          this.motors.push({
            text:   motor.power 
            +" HP , "+motor.nominal_current+" A , " ,
            value: motor.idmotor
          });
        });

        this.selectedMotorId = result.data[0].idmotor;
      });
    },

    fetchMotorTypes: function() {
      this.motorTypes = [];
      this.$http.get(this.$API_URL + "motor_types").then(result => {
        result.data.forEach(motorType => {
          this.motorTypes.push({
            text: motorType.type +", "+motorType.voltage+"V, "+
            motorType.phase+" "+this.$t('motor.phase')+", "+motorType.fi_d_max+" mm",
            value: motorType.idmotor_type
          });
        });

        console.log(result.data);

        this.selectedMotorTypeId = result.data[0].idmotor_type;
      });
    },
  
    saveMotorData: function(isUpdate, item) {
      var targetUrl = isUpdate == false ? "save_motor_perf" : "update_motor_perf";
      item.type = this.selectedMotorTypeId

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + targetUrl,
        data: item
      })
        .then(response => {
          // console.log(response.data);
          this.close();

          if (targetUrl == "save_motor_perf"){
              this.selectedMotorTypeId = item.type
              this.selectedMotorId = item.idmotor
          } 

          this.fetchMotorPerformances(
              this.selectedMotorId
            );
            
          // if (response.data == "1")
          //  window.history.go(-1)
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
